<template>
  <div>
  <table class="table-bordered table-hover tbl datatables" style="width:100%;">
    <thead class="thead-default">
      <tr>
        <th class="text-center">ShippingId</th>
        <th class="text-center">Pending Days</th>
        <th v-if="isCourierCompanyId" class="text-center">Agent Id</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in svcInScanPendingList" :key="index" class="text-center">
        <td>{{item.shippingid}}</td>
        <td>{{item.pendingdays}}</td>
        <td v-if="isCourierCompanyId">{{item.courierid}}</td>
    </tr>
    <tr v-if="svcInScanPendingList.length==0">
      <td colspan="35" align="center">No record found</td>
    </tr>
  </tbody>
  </table><br>
  </div>
</template>


<script>
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading'

export default{
  name: "pendingForReturn",
  components: {
    Paginate,VueElementLoading
  },
  data:function(){
  return {
    pagecount:1,
    }
  },
  props: {
    svcInScanPendingList: {
      type: Array,
      required: true
    },
    isCourierCompanyId: {
      type: Boolean,
      // required:true
    }
  },
  methods:{

  }
}
</script>


<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/svcInScanPending.vue?a3ea4db8